import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Browser} from "@capacitor/browser";
import {AuthService, IdToken} from "@auth0/auth0-angular";
import {Sincronizador} from "../services/sincronizacao/Sincronizador";
import {switchMap} from "rxjs/operators";
import {Capacitor} from "@capacitor/core";
import * as localForage from "localforage";
import {Share} from "@capacitor/share";
import {CapacitorSQLite, SQLiteConnection} from "@capacitor-community/sqlite";
import {createConnection, DataSource} from "typeorm";
import LocalDataSource from "../data-sources/LocalDataSource";
import {Taxon} from "../domain/Taxon";
import {Bioma} from "../domain/Bioma";
import {Pessoa} from "../domain/Pessoa";
import {fromEvent} from "rxjs";
import {ShareService} from "../services/ShareService";
import {SQLiteService} from "../services/sqlite.service";

@Component({
  selector: 'app-folder',
  templateUrl: './folder.page.html',
  styleUrls: ['./folder.page.scss'],
})
export class FolderPage implements OnInit {
  public folder!: string;
  private activatedRoute = inject(ActivatedRoute);
  constructor(
    private sqlite: SQLiteService,
    private shareService: ShareService,
    private sinc: Sincronizador,
    public auth: AuthService) { }
    // user$ = this.auth.isAuthenticated$.pipe(switchMap(() => this.auth.user$));
    // token$ = this.auth.isAuthenticated$.pipe(switchMap(() => this.auth.idTokenClaims$));


  progress = 0

  ngOnInit() {
    LocalDataSource.getRepository(Pessoa).find({take:1}).then()

    // this.folder = this.activatedRoute.snapshot.paramMap.get('id') as string;
    // this.sqlite.db.query("PRAGMA user_version ;", []).then(r=>{
    //   this.versao = r?.values?.[0]
    // })
    // this.sqlite.db.query("PRAGMA table_list", []).then(r=>{
    //   console.log(r)
    // })
    // //
    // this.auth.isAuthenticated$.subscribe( a=>{
    //   if(a){
    //     this.auth.idTokenClaims$.subscribe(t=>{
    //       localStorage.setItem("token",JSON.stringify(t))
    //       const agencia = (t as any).agencia
    //       localStorage.setItem("agencia", agencia)
    //     })
    //   }
    // })
  }

  async gravar(){
    const p = new Pessoa()
    p.nome = 'kik'
    p.email = 'jc@hs.com'
    p.agencia_sigla = 'rnv'

    // await LocalDataSource.manager.transaction(r => {
    //   return r.save(p);
    // })
    // if(runner.isTransactionActive)
    //   await runner.startTransaction()

    // await LocalDataSource.getRepository(Pessoa).save(p)
    await LocalDataSource.transaction(async e => {
      await  e.save(p)
      await this.sqlite.saveToStore()
    })


    // const runner = LocalDataSource.createQueryRunner()
    // await runner.connect()
    // await runner.startTransaction()
    // await runner.manager.save(p)
    // await runner.commitTransaction()
    // await LocalDataSource.getRepository(Pessoa).save(p)
  }

  async ExportDb(): Promise<void> {
    if (Capacitor.getPlatform() !== 'web') {
      await Share.share({
        title: "Banco Fauna",
        text: "texto do bd",
        dialogTitle: "Compartilhar BD",

      })
    } else {
      const db = localForage.createInstance({name: 'jeepSqliteStore', storeName: 'databases'});
      const data = await db.getItem<Uint8Array>("faunaSQLite.db");
      if (!data) return;

      this.initiateDownload("faunaSQLite.db", 'application/vnd.sqlite3', data); //'application/octet-stream' works fine too
    }
  }



  private initiateDownload(filename: string, dataType: string, data: BlobPart) {
    const blob = new Blob([data], { type: dataType });
    const a = document.createElement('a');
    a.href = window.URL.createObjectURL(blob);
    a.download = filename;
    a.click();
  }

  login(){
    // this.auth
    //   .loginWithRedirect({
    //     async openUrl(url: string) {
    //       return Browser.open({ url, windowName: '_self' });
    //     }
    //   })
    //   .subscribe();
  }

  async download(){

      // const bd = await this.sqlite.db.exportToJson("full", false)
      // const data: Blob = new Blob([JSON.stringify(bd.export)], {
      //   type: 'application/json'
      // });
      // saveAs(data,  'bd.json');
  }

  contagem = 0

  uploadBinary(event: any){
      const file = event.target.files[0]
      const reader = new FileReader()
      const fileReader$ = fromEvent(reader, 'load')
      reader.onload = async () => {
        const retorno = reader.result as ArrayBuffer
        const data = new Uint8Array(retorno);



        // Store the data in localForage
        const newDbInstance = localForage.createInstance({ name: 'jeepSqliteStore', storeName: 'databases' });
        await newDbInstance.setItem('faunaSQLite.db', data);
        location.reload()
      }
      reader.readAsArrayBuffer(file)
      return fileReader$
  }

  versao: any = {}

  async contar(){
    this.contagem = await LocalDataSource.getRepository(Taxon).count()
    // const resp  = await this.sqlite.db?.query('select count(*) as contagem from bioma')!! as any
    // console.log('contagem biomas ', resp.values[0])
    // this.contagem = resp.values[0]['contagem']
  }

  uploadPF(event: any) {
      // const file = event.target.files[0]
      // const reader = new FileReader()
      // const fileReader$ = fromEvent(reader, 'load')
      // reader.onload = async () => {
      //   const retorno = reader.result as string
      //   const inicio = new Date().getTime()
      //   const importacao = await this.sqliteService.sqliteConnection.importFromJson(retorno)
      //   console.log('resumo', importacao)
      //   console.log('duracao', new Date().getTime()  - inicio)
      //   const resp  = await this.sqlite.db?.query('select count(*) as contagem from bioma')!! as any
      //   console.log('contagem biomas ', resp.values[0])
      //   this.contagem = resp.values[0].contagem
      // }
      // reader.readAsText(file)
      // return fileReader$
    }
  baixar(){
   this.sinc.verificarSincronizacao()
  }
}
